import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  params: {},
  byId: {},
  actionsloading: false,
});

export function teacherDayTimetableReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_TEACHERDAY_TIMETABLE:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_TEACHERDAY_TIMETABLE_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    default:
      return state;
  }
}
